export default __webpack_public_path__ + "static/media/2.cdae4097.png";